// ═══════════════════════════════════════════════════════════════
// Settings — Layout with sub-navigation (Roles / Users)
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import { IconShieldCog, IconUsers, IconHistory } from '@tabler/icons-react';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ModuleNav from '../../components/layout/ModuleNav';
import type { NavItem } from '../../types/nav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Roles', path: '/settings', icon: IconShieldCog, exact: true },
  { label: 'Users', path: '/settings/users', icon: IconUsers },
  { label: 'Activity Log', path: '/settings/activity', icon: IconHistory },
];

export default function SettingsLayout() {
  const { pathname } = useLocation();

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px', maxWidth: 1200 }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'Settings', to: '/settings' },
          ...(currentPage && currentPage.path !== '/settings' ? [{ label: currentPage.label }] : []),
        ]}
      />
      <ModuleNav items={NAV_ITEMS} accentColor={brand.blurple} />
      <Outlet />
    </div>
  );
}
